




























































import {
  Vue, Component, Prop, PropSync,
} from 'vue-property-decorator';
import {
  SectorsApi, MarketsApi, SettingsApi, Sector, Market,
} from '@compassdigital/foodworks.ts.sdk';
import SystemModule from '@/store/modules/system';
import ConfigurationModal from '@/components/Modal/ConfigurationModal/index.vue';
import ConfigurationDelete from '@/components/Modal/ConfigurationDelete/index.vue';
import AppModule from '@/store/modules/app';

@Component({
  components: {
    ConfigurationModal,
    ConfigurationDelete,
  },
})
export default class ConfigurationList extends Vue {
  @PropSync('listArray', {}) list!: Array<any>;

  @Prop({}) label!: string;

  private rowHoverID: number = -1;

  private isOpen: boolean = false;

  public dialog: boolean = false;

  public dialogDelete: boolean = false;

  public deleteLabel: string = 'Delete';

  public selectedIndex: any = '';

  public updatedList: any[] = [];

  public loading: boolean = false;

  public configurationValue: any = {
    id: '',
    name: '',
    cuisineTypes: [],
    index: '',
  };

  public toggle() {
    this.isOpen = !this.isOpen;
  }

  public onMouseLeave() {
    this.isOpen = false;
    this.rowHoverID = -1;
  }

  public onEdit(id: string, name: string, list: any, index: string) {
    this.selectedIndex = index;
    this.updatedList = list;
    const mappedCuisine = list.find((value: string, i: string) => i === this.selectedIndex);
    this.dialog = true;
    this.configurationValue.name = name;
    this.configurationValue.id = id;
    this.configurationValue.cuisineTypes = mappedCuisine;
  }

  public async onSubmit(value: any) {
    if ((this.$refs.form as any).validate()) {
      if (this.label === 'Sector') {
        const { id }: any = value;
        try {
          this.loading = true;
          const api = new SectorsApi(AppModule.apiConfig);
          await api.patchSector(id, value);
          this.getSectors();
          this.dialog = false;
        } catch (error) {
          console.log('error', error);
        }
        this.loading = false;
      }
      if (this.label === 'Market') {
        const { id }: any = value;
        try {
          this.loading = true;
          const api = new MarketsApi(AppModule.apiConfig);
          await api.patchMarket(id, value);
          this.getMarkets();
          this.dialog = false;
        } catch (error) {
          console.log('error', error);
        }
        this.loading = false;
      }
      if (this.label === 'Cuisines') {
        const { id }: any = value;
        this.updatedList[this.selectedIndex] = value.cuisineTypes;
        const newArrayObject: any = {
          cuisineTypes: [],
        };
        newArrayObject.cuisineTypes = this.updatedList;
        try {
          this.loading = true;
          const api = new SettingsApi(AppModule.apiConfig);
          const data = await api.patchSettings((newArrayObject) as any);
          this.getCuisines();
          this.dialog = false;
        } catch (error) {
          console.log('err', error);
        }
        this.loading = false;
      }
    }
  }

  public async getSectors() {
    await SystemModule.fetchSectors();
    this.list = SystemModule.sectors;
  }

  public async getMarkets() {
    await SystemModule.fetchMarkets();
    this.list = SystemModule.markets;
  }

  public async getCuisines() {
    const api = new SettingsApi(AppModule.apiConfig);
    const cuisine: any = await api.getSettings();
    const { cuisineTypes } = cuisine.data;
    const cuisinesArrays = cuisineTypes.sort((a:any, b:any) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
    this.list = cuisinesArrays;
  }

  public close() {
    this.dialog = false;
    this.dialogDelete = false;
  }

  public onDeleteToggle(id: any, value: any, list: any, selecetIndex: string) {
    this.dialogDelete = true;
    this.configurationValue.id = id;
    this.configurationValue.name = value;
    const mappedCuisine = list.find((v: string, index: string) => index === selecetIndex);
    this.configurationValue.cuisineTypes = mappedCuisine;
    this.selectedIndex = selecetIndex;
    this.updatedList = list;
  }

  public async onDelete(value: any) {
    if (this.label === 'Sector') {
      const { id }: any = value;
      try {
        this.loading = true;
        const api = new SectorsApi(AppModule.apiConfig);
        await api.deleteSector(id, value);
        this.getSectors();
        this.dialogDelete = false;
      } catch (error) {
        console.log('error', error);
      }
      this.loading = false;
    }
    if (this.label === 'Market') {
      const { id }: any = value;
      try {
        this.loading = true;
        const api = new MarketsApi(AppModule.apiConfig);
        await api.deleteMarket(id);
        this.getMarkets();
        this.dialogDelete = false;
      } catch (error) {
        console.log('error', error);
      }
      this.loading = false;
    }
    if (this.label === 'Cuisines') {
      this.updatedList.splice(this.selectedIndex, 1);
      const newArrayObject: any = {
        cuisineTypes: [],
      };
      newArrayObject.cuisineTypes = this.updatedList;
      try {
        this.loading = true;
        const api = new SettingsApi(AppModule.apiConfig);
        const data = await api.patchSettings((newArrayObject) as any);
        this.getCuisines();
        this.dialogDelete = false;
      } catch (error) {
        console.log('err', error);
      }
      this.loading = false;
    }
  }
}
